import {
	Breadcrumbs,
	Card,
	Grid,
	makeStyles,
	Switch,
	Typography,
} from "@material-ui/core/";
import MaterialTable from "material-table";
import React from "react";

const useStyles = makeStyles((theme) => ({
	title: {
		// margin: theme.spacing(1, 0),
	},
}));

const TableListConfig = (props) => {
	const classes = useStyles();

	const { getDataTables, BaseUrl, tableRef, pageSize, fetchAPI } = props;

	const handleStatus = async (rowData) => {
		let status = "";
		if (rowData.status === true) {
			status = false;
		}
		if (rowData.status === false) {
			status = true;
		}

		const result = await fetchAPI("status", {
			id: rowData.id,
			status: status,
		});
		return result;
	};

	const columns = [
		{ title: "nama", field: "nama" },
		{ title: "deskripsi", field: "deskripsi" },
		{
			title: "Status",
			field: "status",
			filtering: false,
			render: (rowData) => (
				<>
					<Grid container alignItems="center" spacing={1}>
						<Grid item>InActive</Grid>
						<Switch
							checked={rowData.status ? 1 : 0}
							onChange={() => handleStatus(rowData)}
							color="primary"
							inputProps={{ "aria-label": "primary checkbox" }}
						/>
						<Grid item>Active</Grid>
					</Grid>
				</>
			),
		},
	];
	return (
		<Grid
			item
			direction="column-reverse"
			justifyContent="space-between"
			alignItems="stretch"
		>
			<Grid item>
				<Card className={classes.title}>
					<Breadcrumbs aria-label="breadcrumb" style={{ padding: "10px" }}>
						<Typography color="textPrimary" style={{ padding: "10px" }}>
							Dashboard
						</Typography>
						<Typography color="textPrimary" variant="h6">
							List Config
						</Typography>
					</Breadcrumbs>
				</Card>

				<div style={{ marginTop: "20px" }}>
					<MaterialTable
						title="List Config"
						tableRef={tableRef}
						columns={columns}
						data={getDataTables({ url: `${BaseUrl}` })}
						options={{
							search: false,
							actionsColumnIndex: -1,
							paginationType: "stepped",
							pageSize: pageSize,
							pageSizeOptions: [5, 10, 50, 100],
							headerStyle: {
								backgroundColor: "#67A3D5",
								color: "#FFF",
							},
						}}
					/>
				</div>
			</Grid>
		</Grid>
	);
};

export default TableListConfig;
